import React, { useState, useEffect } from "react";
import { TablePagination } from "@mui/material";
import { useQueryParams } from "../../hooks";
import { useDebounce } from "../../hooks";
import { useOutletContext } from "react-router-dom";
import { getPurchasedInterviewData } from "./Helper"; // new API

export const MockInterviewList = () => {
  const [userData, setUserData] = useState([]);
  const { getParam, setMultiParam } = useQueryParams();
  const currentPage = getParam("page");
  const currentLimit = getParam("pageSize");
  const [clientsPage, setClientsPage] = useState(parseInt(currentPage) || 0);
  const [clientsLimit, setClientsLimit] = useState(parseInt(currentLimit) || 10);
  const [userTotal, setUserTotal] = useState(0);
  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search, 1000);
  const context = useOutletContext();

  const handleChangePage = (e, newPage) => {
    setClientsPage(newPage);
    fetchInterviewData(newPage, clientsLimit);
  };

  const handleChangeRowsPerPage = (event) => {
    setClientsLimit(parseInt(event.target.value, 10));
    setClientsPage(0);
    fetchInterviewData(0, parseInt(event.target.value, 10));
  };

  const fetchInterviewData = (page, limit) => {
    getPurchasedInterviewData(page + 1, limit, debounceSearch)
      .then((data) => {
        console.log(data.data.data);
        setUserData(data.data.data);
        setUserTotal(data.data.meta.total);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    context(["Dashboard", "Purchased Mock Interview"]);
    fetchInterviewData(clientsPage, clientsLimit);
  }, [debounceSearch]);

  useEffect(() => {
    setMultiParam({ page: clientsPage, pageSize: clientsLimit });
  }, [clientsPage, clientsLimit]);

  return (
    <div className="p-5 shadow-md bg-white">
      <div className="grid grid-cols-6 gap-2">
        <h3 className="col-span-5 text-lg uppercase tracking-wider font-bold" style={{ color: "#2EBAA3" }}>
          Purchased Mock Interviews
        </h3>
        <input
          type="text"
          id="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search"
          className="px-3 py-1.5 mr-2 mb-2 form-control block w-full text-base font-normal text-gray-700 bg-white border border-gray-300 rounded"
        />
      </div>
      <br />
      <div className="overflow-x-auto relative">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th className="py-3 px-6 uppercase">Sr.</th>
              <th className="py-3 px-6 uppercase">Name</th>
              <th className="py-3 px-6 uppercase">Prolegion ID</th>
              <th className="py-3 px-10 uppercase">Email</th>
              <th className="py-3 px-6 uppercase">Phone</th>
              <th className="py-3 px-6 uppercase">Price</th>
              <th className="py-3 px-4 uppercase">Used Credits </th>
              <th className="py-3 px-4 uppercase">Total Credits </th>
              <th className="py-3 px-6 uppercase">Purchase Date</th>
            </tr>
          </thead>
          <tbody>
            {userData?.map((user, index) => (
              <tr key={index} className="bg-white border-b">
                <td className="py-4 px-6">{index + 1 + clientsPage * clientsLimit}</td>
                <td className="py-4 px-6">
                  {user?.user?.firstName} {user?.user?.lastName}
                </td>
                <td className="py-4 px-6">{user?.user?.username}</td>
                <td className="py-4 px-6">{user?.user?.email}</td>
                <td className="py-4 px-6">{user?.user?.phone}</td>
                <td className="py-4 px-3">Rs {user?.total_credits * 149}</td>
                <td className="py-4 px-6">{user?.user_credits}</td>
                <td className="py-4 px-6">{user?.total_credits}</td>
                <td className="py-4 px-6">
                  {user?.lastPurchaseAt ? new Date(user.lastPurchaseAt).toLocaleDateString('en-GB') : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TablePagination
        component="div"
        count={userTotal}
        page={clientsPage}
        onPageChange={handleChangePage}
        rowsPerPage={clientsLimit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
      />
    </div>
  );
};
